import { type DomainAccessControlConfig } from 'domains/customers/utils/domain/accessControl'
import { Permission } from 'domains/customers/access-control/permissions'
import { Flipper } from 'domains/customers/access-control/flippers'

export const customersAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CustomersView],
  flippers: [Flipper.rt_ipp_customer_admin_view],
}

export const customersPrivacyRequestsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CustomersPrivacyRequestsModifyAccess],
  flippers: [Flipper.rt_ipp_customer_admin_view],
}
